import { Component, OnInit, ElementRef, ViewChild, AfterViewInit, NgZone } from '@angular/core';
import { ApiService } from "../../core/services/api.service";
import { environment } from '../../../environments/environment';
import { Router } from '@angular/router';
import { AuthService } from '../../core/auth/auth.service';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { HeaderService } from 'src/app/core/services/header.service';
import { AudioService } from 'src/app/core/services/audio.service';
import { UserService } from 'src/app/core/services/user.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import videojs from '../../../assets/js/play.es.js';
import '../../../assets/js/videojs-playlist.es.js';
import '../../../assets/js/videojs-playlist-ui.es.js';
import { PlayerService } from 'src/app/core/services/player.service';
import * as CryptoJS from 'crypto-js';
import { ToastrService } from 'ngx-toastr';
import { NgForm } from '@angular/forms';

declare var $: any;
@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss']
})

export class SearchComponent implements OnInit {
  @ViewChild('chatContainer') private chatContainer: ElementRef;
  loader: boolean = false;
  page_loader: boolean = false;
  search_group: boolean = false;
  searchId: number = null;
  searchQuery: string = '';
  searchText: string = '';
  sidebar: boolean = true;
  results = []; // Array of chat messages
  historys = []; // Array of chat messages
  currentText = ''; // Holds the current bot message being typed
  typingSpeed = 2050; // Speed in milliseconds for typing effect 
  currentVideoTime: any = null;
  songIndex: any;
  indexAudio: number = 0;
  jsonToggle: string = "";
  audioLists = [];
  useOldApi: string = "yes";
  translationModel: string = "";
  rerankModel: string = "";
  translate_text_flag: string = "";
  update_question_form: boolean = false;
  update_option_form: boolean = false;
  allDefaultOptions = [];
  formUpdateoption: any = {};

  startTime: number;
  endTime: number;
  sourceURL: string;
  safeSourceURL: SafeResourceUrl;
  decrypted: any;
  encrypted: any;
  plainText: any;
  cipherText: any;
  interVal: any;
  video: any;
  userAgent: any;
  player: any;
  next_video: any = false;
  subTitle: any = [];
  init_video: any = false;
  init_audio: any = false;
  expandedStates: boolean[][] = [];
  translation_loader = false;
  toggleSidebar: boolean = true;
  indexOptions: any = [];
  rerankOptions: any = [];
  rerankModels: any = [];
  indexMechanism: any = [];
  groupLists: any = [];
  indexBatch: any = [];
  selectedindexValue: string = "";// Default value
  selectedMechanismValue: string = "";
  selectedBatchValue: string = "";
  selectedRerankValue: string = "";
  selectedllmqaValue: string = "";
  selectedUseKnValue: string = "";
  playedVideoSlug: string;
  playedAudioSlug: string;



  selected_pinecone_similarity_threshold: string = "";
  selected_qna_threshold_1: string = "";
  selected_qna_threshold_2: string = "";
  selected_user_answer_threshold: string = "";
  selected_llm_score_threshold: string = "";

  value: number;
  top_k: number;
  top_k_rerank: number;
  loaderSearch = false;
  disabledAddButton: boolean[][] = [];
  checkboxButton: boolean;
  userScores: (number | string)[][] = [];
  selectedUserScore: number | string = "";
  init_model: boolean = false;
  init_model_answer: boolean = false;
  init_model_question: boolean = false;
  selected_user_score: (number | null);
  questionList: any = [];
  questionListRelated: any = [];
  questionRelatedList: any = [];
  questionText: string = "";
  selected_search_result: any;
  selected_result: any;
  questionDropdown: boolean = false;
  questionMainDropdown: boolean = false;
  formData = {
    group_id: '',
    question: '',
    translation: '',
    english_question: '',
    keywords: '',
    isCore: false,
    core_questions: [],
  };
  formDataQuestion = {
    group_id: null,
    question: '',
    translation: '',
    english_question: '',
    keywords: '',
    isCore: false,
  };

  formDataQuestionTemp = {
    translation: '',
  };
  formUpdateQuestion = {
    id: '',
    group_id: '',
    english_question: '',
    user_question: '',
    translation: '',
    question_keywords: '',
    is_core_question: false,
    is_active: false,
    visible_to_user: false,
    no_good_question: false,
  };

  options: any = {
    floor: 0,
    ceil: 1,
    step: 0.1, // Step size of 0.1
    showTicks: false, // Show small tick marks
    // showTicksValues: true, // Show numbers as labels
    tickStep: 0.1, // Space between tick labels
    tickValueStep: 0.1 // Show values at every tick
  };
  selectedAudio: any;
  playeraudio: any;

  // speechInput = '';
  isRecording = false;
  error: any = {};
  statusMessage = 'Click the mic to speak';
  recognition: any;
  listOfNumber: { label: string, value: number }[] = [];


  constructor(private apiService: ApiService, private authService: AuthService, private router: Router,
    private http: HttpClient, private headerService: HeaderService, private ngZone: NgZone,
    private audioService: AudioService, private userService: UserService, private sanitizer: DomSanitizer,
    private playerService: PlayerService, private toasterService: ToastrService,) {
    if (!('webkitSpeechRecognition' in window)) {
      this.statusMessage = 'Speech recognition is not supported on this browser.';
    } else {
      // Initialize recognition with zone for Angular compatibility
      this.recognition = new (window as any).webkitSpeechRecognition();
      this.recognition.continuous = false;
      this.recognition.interimResults = true;
      this.recognition.lang = 'hi-IN';

      this.recognition.onstart = () => {
        this.ngZone.run(() => {
          this.isRecording = true;
          this.statusMessage = 'Listening...';
        });
      };

      this.recognition.onresult = (event: any) => {
        let finalTranscript = '';


        for (let i = event.resultIndex; i < event.results.length; i++) {
          const transcript = event.results[i][0].transcript;
          if (event.results[i].isFinal) {
            finalTranscript += transcript;
          }
          // this.searchQuery = finalTranscript;
        }

        this.ngZone.run(() => {
          this.searchQuery += finalTranscript;
          this.statusMessage = finalTranscript ? 'Speech detected!' : 'Listening...';
        });
      };

      this.recognition.onerror = (event: any) => {
        this.ngZone.run(() => {
          this.statusMessage = `Error: ${event.error}`;
          this.stopSpeechRecognition();
        });
      };

      this.recognition.onend = () => {
        this.ngZone.run(() => this.stopSpeechRecognition());
      };
    }
  }

  generateListOfNumberOptions(): { label: string, value: number }[] {
    const options = [];
    options.push({
      label: 'select a option',
      value: ''
    });
    for (let i = 1; i <= 9; i++) {
      const val = i / 10;
      options.push({
        label: val.toFixed(1),
        value: val
      });
    }
    options.push({
      label: 1,
      value: 1
    });
    return options;
  }

  allowOnlyNumbers(event: KeyboardEvent) {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode < 48 || charCode > 57) {
      event.preventDefault(); // Prevent non-numeric input
    }
  }

  closeDropdown() {
    this.questionDropdown = false;
  }
  openDropdown() {
    this.questionDropdown = true;
  }
  closeMainDropdown() {
    setTimeout(() => {
      this.questionMainDropdown = false;
    }, 1000);
  }
  openMainDropdown() {
    this.questionMainDropdown = true;
  }

  onQuestionBlur(text: any, formDataQuestion: any) {
    if (text.length > 1)
      this.callTranslationApi(text, formDataQuestion)
  }

  toggleExpand(i: number, j: number) {
    if (!this.expandedStates[i]) {
      this.expandedStates[i] = [];
    }
    this.expandedStates[i][j] = !this.expandedStates[i][j];
  }

  callTranslationApi(e: any, model: any) {
    if (e > 1) return;
    this.translation_loader = true;
    this.apiService
      .callGetAPI("v2/get_hindi_translation?english_text=" + e, environment.userApiUrl)
      .subscribe(
        (data) => {
          this.translation_loader = false;
          if (data['response']) {
            model.translation = data['response'];
            console.log(data['response']);
            return false;
          }
        },
        (error) => {
          this.apiService.failureResponse(error, true);
          this.translation_loader = false;
        }
      );
  }

  callEnglishTranslationApi(e: any, model: any) {
    if (e > 1) return;
    this.translation_loader = true;
    this.apiService
      .callGetAPI("v2/get_english_translation?english_text=" + e, environment.userApiUrl)
      .subscribe(
        (data) => {
          this.translation_loader = false;
          if (data['response']) {
            model.english_question = data['response'];
            console.log(data['response']);
            return false;
          }
        },
        (error) => {
          this.apiService.failureResponse(error, true);
          this.translation_loader = false;
        }
      );
  }

  getPathAccess = () => {
    this.page_loader = true;
    this.apiService
      .callGetAPI("v2/customer/subscription", environment.userApiUrl)
      .subscribe(
        (data) => {
          this.page_loader = false;
          if (data['response'].is_keertan_viewer != 1) {
            this.router.navigate(['404']);
            return false;
          }
        },
        (error) => {
          this.apiService.failureResponse(error, true);
        }
      );
  }

  toggleSidebarFN = () => {
    this.toggleSidebar = !this.toggleSidebar;
  }

  getGroupALL = () => {
    this.apiService
      .callGetAPI("v2/group-list", environment.userApiUrl)
      .subscribe(
        (data) => {
          this.groupLists = data['response'];
        },
        (error) => {
          this.apiService.failureResponse(error, true);
        }
      );
  }

  getSearchBatch = () => {
    this.page_loader = true;
    this.apiService
      .callGetAPI("v2/get-batch", environment.userApiUrl)
      .subscribe(
        (data) => {
          this.page_loader = false;
          this.indexBatch = data['response'];
        },
        (error) => {
          this.page_loader = false;
          this.apiService.failureResponse(error, true);
        }
      );
  }

  getSearchMechanism = () => {
    this.page_loader = true;
    this.apiService
      .callGetAPI("v2/get-mechanism", environment.userApiUrl)
      .subscribe(
        (data) => {
          this.page_loader = false;
          this.indexMechanism = data['response'];
        },
        (error) => {
          this.page_loader = false;
          this.apiService.failureResponse(error, true);
        }
      );
  }

  getSearchIndex = (id: any) => {
    this.page_loader = true;
    this.apiService
      .callGetAPI("v2/get-index/" + id, environment.userApiUrl)
      .subscribe(
        (data) => {
          this.page_loader = false;
          this.indexOptions = data['response'];
        },
        (error) => {
          this.page_loader = false;
          this.apiService.failureResponse(error, true);
        }
      );
  }

  getSearchRerank = () => {
    this.page_loader = true;
    this.apiService
      .callGetAPI("v2/get-rerank", environment.userApiUrl)
      .subscribe(
        (data) => {
          this.page_loader = false;
          this.rerankOptions = data['response'];
        },
        (error) => {
          this.page_loader = false;
          this.apiService.failureResponse(error, true);
        }
      );
  }

  getRerankModel = () => {
    this.page_loader = true;
    this.apiService
      .callGetAPI("v2/get-rerank-model", environment.userApiUrl)
      .subscribe(
        (data) => {
          this.page_loader = false;
          this.rerankModels = data['response'];
        },
        (error) => {
          this.page_loader = false;
          this.apiService.failureResponse(error, true);
        }
      );
  }


  onMechanismValueChange(value: string) {
    // this.indexMechanism.find((id)=>id==value) 
    const found = this.indexMechanism.find(item => item.value === value);
    let id = found ? found.id : null; // Return id if found, otherwise null
    this.getSearchIndex(id)
  }
  onValueChange(value: string) {
  }

  checkSearchIndexStatus = () => {
    this.page_loader = true;
    this.apiService
      .callGetAPI("v2/static-data/lecture_search_index", environment.userApiUrl)
      .subscribe(
        (data) => {
          this.page_loader = false;
          if (data['response'] == 1) {
            this.getSearchMechanism()
            this.getSearchIndex(1)
            this.getSearchRerank()
            this.getRerankModel()
            this.getSearchBatch()

          }
        },
        (error) => {
          this.apiService.failureResponse(error, true);
        }
      );
  }
  getAllDefaultOption = () => {
    this.apiService
      .callGetAPI("v2/option-list/llm_default_admin_option", environment.userApiUrl)
      .subscribe(
        (data) => {
          this.allDefaultOptions = data["response"]
          this.allDefaultOptions.forEach(item => {
            this.formUpdateoption[item.option_name] = item.option_value;
          });
          this.selectedMechanismValue = this.formUpdateoption.query_method;
          this.selectedindexValue = this.formUpdateoption.query_index;
          this.selectedBatchValue = this.formUpdateoption.batch_name;
          this.selectedRerankValue = this.formUpdateoption.rerank_option;
          this.selectedllmqaValue = this.formUpdateoption.use_qna;
          this.selectedUseKnValue = this.formUpdateoption.use_kn;
          this.value = this.formUpdateoption.alpha;
          this.top_k = this.formUpdateoption.top_k;
          this.top_k_rerank = this.formUpdateoption.top_k_rerank;
          this.translationModel = this.formUpdateoption.translation_model;
          this.translate_text_flag = "no";
          this.selected_pinecone_similarity_threshold = this.formUpdateoption.pinecone_similarity_threshold;
          this.selected_qna_threshold_1 = this.formUpdateoption.qna_threshold_1;
          this.selected_qna_threshold_2 = this.formUpdateoption.qna_threshold_2;
          this.rerankModel = this.formUpdateoption.rerank_model;
          this.selected_user_answer_threshold = this.formUpdateoption.user_answer_threshold;
          this.selected_llm_score_threshold = this.formUpdateoption.llm_score_threshold;
        },
        (error) => {
          this.apiService.failureResponse(error, true);
        }
      );
  }

  ngOnInit() {
    this.listOfNumber = this.generateListOfNumberOptions()
    this.getAllDefaultOption()
    this.getGroupALL()
    this.getGroup()
    this.indexOptions = [];
    this.rerankOptions = [];
    this.rerankModels = [];
    this.getPathAccess();
    this.checkSearchIndexStatus();
    this.getHistory();
    this.getAllQuestions();
    this.safeSourceURL = this.sanitizer.bypassSecurityTrustResourceUrl(this.sourceURL);

  }


  playaudio(e: any) {
    this.playedVideoSlug = null;
    this.playedAudioSlug = e.url;
    console.log("🚀 ~ SearchComponent ~ playaudio ~ playaudio:", e)

    this.closeVideo()
    this.selectedAudio = e;
    let audioUrl = e.url;
    this.init_audio = true;


    this.playeraudio = videojs('audio-player', {
      controls: true,
      autoplay: false,
      preload: 'auto',
      controlBar: {
        children: [
          'playToggle',        // Play/Pause button
          'currentTimeDisplay', // Current time
          'progressControl',    // Progress bar
          'durationDisplay',    // Total duration
          'volumePanel',        // Volume control
          // Remove 'fullscreenToggle' here
        ],
      },
    });

    this.playeraudio.src({
      src: audioUrl,
      type: 'application/x-mpegURL',
    });

    this.playeraudio.ready(() => {
      console.log('playeraudio is ready');
    });

    this.playeraudio.ready(() => {
      console.log(this.timeToSeconds(e.startTime))
      this.playeraudio.currentTime(this.timeToSeconds(e.startTime));
      this.playeraudio.play();
    });

    this.playeraudio.on('timeupdate', () => {
      const currentTime = this.playeraudio.currentTime();
      this.currentVideoTime = this.secondsToTimeFormat(currentTime)
    });

    this.playeraudio.on('error', () => {
      console.error('Error playing the audio file:', this.playeraudio && this.playeraudio.error());
    });

  }

  timeToSeconds(timeStr: any) {
    // Extract time before comma
    const [timePart] = timeStr.split(',');
    const [hours, minutes, seconds] = timePart.split(':').map(Number);

    return hours * 3600 + minutes * 60 + seconds;
  }

  ngOnDestroy(): void {
    this.playedAudioSlug = null;
    this.currentVideoTime = null;
    if (this.playeraudio) {
      this.playeraudio.pause();
      setTimeout(() => {
        this.init_audio = false;
      }, 5)
    }
  }

  jsonToggleSet(e: string) {
    if (this.jsonToggle == e) {
      this.jsonToggle = null;
    } else {
      this.jsonToggle = e;
    }
  }



  toggleSpeechRecognition() {
    if (this.isRecording) {
      this.stopSpeechRecognition();
    } else {
      this.searchQuery = ''; // Reset input
      this.recognition.start();
    }
  }

  stopSpeechRecognition() {
    this.isRecording = false;
    this.recognition.stop();
    this.statusMessage = 'Click the mic to speak';
    setTimeout(() => {
      this.onSubmit()
    }, 500);
  }

  getHistory() {
    this.apiService
      .callGetAPI("v2/search-history", environment.userApiUrl)
      .subscribe(
        (data) => {
          this.historys = data['response'];
        },
        (error) => {
          this.apiService.failureResponse(error, true);
        }
      );
  }

  getTranslationText(e: string): Promise<string> {
    return new Promise((resolve) => {
      this.apiService
        .callGetAPI("v2/get_hindi_translation?english_text=" + e, environment.userApiUrl)
        .subscribe(
          (data) => {
            if (data['response']) {
              resolve(data['response']);
            } else {
              resolve(e);
            }
          },
          (error) => {
            resolve(e);
          }
        );
    });
  }


  async onSubmit() {
    if (this.searchQuery.length < 3) {
      return;
    }
    this.loader = true;
    this.searchText = this.searchQuery;
    this.searchQuery = "";
    const translatedQuery = await this.getTranslationText(this.searchText);
    setTimeout(() => {
      this.scrollToBottom()
    }, 0);

    const queryParams =
      `s=${this.searchText}` +
      `&translatedQuery=${translatedQuery}` +
      `&searchId=${this.searchId}` +
      `&query_index=${this.selectedindexValue}` +
      `&mechanism=${this.selectedMechanismValue}` +
      `&batch=${this.selectedBatchValue}` +
      `&alpha=${this.value}` +
      `&top_k_rerank=${this.top_k_rerank}` +
      `&top_k=${this.top_k}` +
      `&rerank_option=${this.selectedRerankValue}` +
      `&use_qna=${this.selectedllmqaValue}` +
      `&useOldApi=${this.useOldApi}` +
      `&translationModel=${this.translationModel}` +
      `&rerankModel=${this.rerankModel}` +
      `&translate_text_flag=${this.translate_text_flag}` +
      `&get_from_kn=${this.selectedUseKnValue}` +
      `&pinecone_similarity_threshold=${this.selected_pinecone_similarity_threshold}` +
      `&qna_threshold_1=${this.selected_qna_threshold_1}` +
      `&qna_threshold_2=${this.selected_qna_threshold_2}` +
      `&user_answer_threshold=${this.selected_user_answer_threshold}` +
      `&llm_score_threshold=${this.selected_llm_score_threshold}`;
    const url = `v2/search?${queryParams}`;
    this.apiService
      .callGetAPI(url, environment.userApiUrl)
      .subscribe(
        (data) => {
          this.searchId = null;
          this.loader = false;
          if (!data['response']) {
            this.toasterService.error('', 'failed to receive response please try again later.');
            return;
          }
          this.results.push(data['response'])
          this.getHistory()
          this.results.map((obj: any, i: number) => {
            this.userScores[i] = [];
            this.disabledAddButton[i] = [];
            this.expandedStates[i] = [];
            obj.search_result.map((ineerObj: any, j: number) => {
              this.userScores[i][j] = "";
              this.disabledAddButton[i][j] = false;
              this.expandedStates[i][j] = false
              if (ineerObj.asset.audio_title) {
                this.audioLists.push(ineerObj.asset)
              }
            })
          })
          setTimeout(() => {
            this.scrollToBottomSome()
          }, 2000);
        },
        (error) => {
          this.searchId = null;
          console.log('---->error   ', error)
          this.loader = false;
          this.getHistory()
          this.toasterService.success('', 'failed to receive response please try again later.');
          this.apiService.failureResponse(error, true);
        }
      );
  }

  setSearch(e: any, search: string) {
    this.searchQuery = search;
    this.searchId = e
    setTimeout(() => {
      this.onSubmit()
    }, 50);
  }

  getSubmit(e: any) {
    this.searchQuery = e;
    setTimeout(() => {
      this.onSubmit()
    }, 200);
  }

  scrollToBottomSome(): void {
    try {
      // Calculate the new scroll position by adding 400px to the current scroll position
      this.chatContainer.nativeElement.scrollTop += 400;

      // If you want to ensure it does not exceed the maximum scroll height, you can do this:
      const maxScrollTop = this.chatContainer.nativeElement.scrollHeight;
      if (this.chatContainer.nativeElement.scrollTop > maxScrollTop) {
        this.chatContainer.nativeElement.scrollTop = maxScrollTop;
      }
    } catch (err) {
    }
  }


  scrollToBottom(): void {
    try {
      this.chatContainer.nativeElement.scrollTop = this.chatContainer.nativeElement.scrollHeight;
    } catch (err) {
    }
  }

  hideSideBar(e: any) {
    this.sidebar = e
  }

  playSong(i: number) {
    if (this.checkUser()) {
      if (localStorage.getItem('currentUser')) {
        localStorage.setItem('queueList', JSON.stringify(this.audioLists));
        this.audioService.setData({
          'songList': this.audioLists,
          'selectedindex': i,
        });
        this.audioService.newStateSong('play');
        this.songIndex = i;
      } else {
        this.userService.displayPopup('sign-in');
        return false;
      }
    }
  }

  onImageError(event: Event) {
    const target = event.target as HTMLImageElement;
    target.src = 'assets/images/page-loader.png';
  }

  resetFormData() {
    this.formData = {
      group_id: '',
      question: '',
      translation: '',
      english_question: '',
      keywords: '',
      isCore: false,
      core_questions: [],
    };
    this.questionText = "";
    this.questionList = [];
  }

  ngOnDestroyModelBox(e: any) {
    this.getQuestionListRelated(e.isAdded)
    console.log("ngOnDestroyModelBox ", e)
    this.questionListRelated = [];
    if (e) {
      this.formData.group_id = e.isGroup;
      this.formData.question = e.query;
      this.formData.translation = e.translated_text;
    } else {
      this.resetFormData()
    }
    this.init_model = !this.init_model;
  }
  ngOnDestroyModelBoxQuestion(e = null) {
    if (e) {
      this.activeGroupId = e
    }
    this.init_model_question = !this.init_model_question;
    this.questionListRelated = [];
  }

  noGoodAnswer(e: any, status: any) {
    const param = {
      user_question: e.query,
      no_good_question: status ? 1 : 0
    }
    this.apiService.callPostAPI('v2/no-good-answer', param, environment.userApiUrl)
      .subscribe(
        (data: any) => {
          this.toasterService.success('', data.message);
        },
        (error) => {
          console.log('error', error)
        }
      );
  }

  getRelatedQuestionList(event: any) {
    const searchValue = event.target.value;
    if (searchValue.length < 2) {
      this.questionListRelated = [];
      return
    }

    this.apiService
      .callGetAPI("search/question?q=" + searchValue + "&page=1", environment.searchApiUrl)
      .subscribe(
        (data) => {
          if (data['statusCode'] === 200 && data['error'] === false) {
            this.questionListRelated = data['response'].data;
          }
        },
        (error) => {
          this.toasterService.success('', 'failed to receive response please try again later.');
          this.apiService.failureResponse(error, true);
        }
      );
  }

  getQuestionList(event: any) {
    const searchValue = event.target.value;
    if (searchValue.length < 2) {
      this.questionList = [];
      return
    }

    this.apiService
      .callGetAPI("search/question?q=" + searchValue + "&page=1", environment.searchApiUrl)
      .subscribe(
        (data) => {
          if (data['statusCode'] === 200 && data['error'] === false) {
            this.questionList = data['response'].data;
          } else {
            this.toasterService.success('', 'failed to receive response please try again later.');
            return;
          }
        },
        (error) => {
          console.log('---->error   ', error)

          this.toasterService.success('', 'failed to receive response please try again later.');
          this.apiService.failureResponse(error, true);
        }
      );
  }

  onCheckboxChange(event: any, id: number) {
    if (event.target.checked) {
      // Add ID if checked
      if (!this.formData.core_questions.includes(id)) {
        this.formData.core_questions.push(id);
      }
    } else {
      // Remove ID if unchecked
      this.formData.core_questions = this.formData.core_questions.filter(
        qid => qid !== id
      );
    }
  }

  saveAllQuestionAnswer() {
    this.apiService.callPostAPI('v2/question-answer-xref', [], environment.userApiUrl)
      .subscribe(
        (data: any) => {
          this.toasterService.success('', "data save successfully");
        },
        (error) => {
          console.log('error', error)
        }
      );
  }

  // addQuestion(e: any) {
  //   console.log("🚀 ~ SearchComponent ~ addQuestion ~ addQuestion:", e)
  //   const apiUrl = 'v2/admin-subscription';
  //   const param = {
  //     user_question: e.query,
  //     translated_question: e.translated_text,
  //     question_keywords: "",
  //     is_core_question: "",
  //     pinecone_updated: 0,
  //     related_question: "",
  //   }
  // this.apiService.callPostAPI(apiUrl, param, environment.userApiUrl)
  //   .subscribe(
  //     (data: any) => {

  //     },
  //     (error) => {
  //       console.log('error', error)

  //     }

  //   );
  // }

  onUserScoreChange(i: number, j: number) {
    this.disabledAddButton[i][j] = false;
  }
  ngOnDestroyModelBoxAnswer() {
    this.init_model_answer = false;
  }

  addDifferentAnswer(e: any, result: any, user_score: number) {
    if (user_score) {
      this.selected_search_result = e;
      this.selected_result = result;
      this.selected_user_score = user_score;
      this.init_model_answer = true;
    } else {
      this.toasterService.error('', 'Please select user score');
    }
  }

  onSubmitDiffrentFrom() {
    this.questionText = "";
    const e = this.selected_search_result;
    const result = this.selected_result;
    const apiUrl = 'v2/add-different-answer';
    const param = {
      user_question: result.query,
      asset_id: e.asset.id,
      asset_type: e.metadata.type,
      index_name: result.query_index,
      mechanism_name: result.query_method,
      batch_name: e.metadata.batch_name,
      vector_id: e.index_vector_id,
      similarity_score: e.similarity_score,
      reranking_score: e.reranking_score,
      start_time: e.metadata.start,
      end_time: e.metadata.end,
      text: e.page_content,
      user_score: this.selected_user_score,
      alpha: result.alpha,
      top_k: result.top_k,
      top_k_rerank: result.top_k_rerank,
      rerank_option: result.rerank_option,
      final_score: e.final_score,
      source_index: e.source_index,
      question_ids: this.formData.core_questions,
    }
    this.apiService.callPostAPI(apiUrl, param, environment.userApiUrl)
      .subscribe(
        (data: any) => {
          this.toasterService.success('', data.message);
          this.selected_search_result = null;
          this.selected_result = null;
          this.selected_user_score = null;
          this.init_model_answer = false;
          this.questionList = [];
          return;
        },
        (error) => {
          if (error.error.statusCode === 422) {
            this.error = error.error.message;
          } else {
            this.error = {};
            this.toasterService.error('', (error.error.message) ? error.error.message : error.message);
          }
        }
      );
  }



  addAnswer(e: any, result: any, userselectedScores: any, i: number, j: number) {
    console.log("🚀 ~ SearchComponent ~ addAnswer ~ addAnswer:", e)

    if (!userselectedScores) {
      this.toasterService.error('', 'Please select user score');
      return;
    }
    this.disabledAddButton[i][j] = true;
    const apiUrl = 'v2/add-answer';
    const param = {
      user_question: result.query,
      asset_id: e.asset.id,
      asset_type: e.metadata.type,
      index_name: result.query_index,
      mechanism_name: result.query_method,
      batch_name: e.metadata.batch_name,
      vector_id: e.index_vector_id,
      similarity_score: e.similarity_score,
      reranking_score: e.reranking_score,
      start_time: e.metadata.start,
      end_time: e.metadata.end,
      text: e.page_content,
      user_score: userselectedScores,
      alpha: result.alpha,
      top_k: result.top_k,
      top_k_rerank: result.top_k_rerank,
      rerank_option: result.rerank_option,
      final_score: e.final_score,
      source_index: e.source_index,
    }
    this.loaderSearch = true;
    this.apiService.callPostAPI(apiUrl, param, environment.userApiUrl)
      .subscribe(
        (data: any) => {
          this.toasterService.success('', data.message);
          this.loaderSearch = false;
          return;
        },
        (error) => {
          this.loaderSearch = false;
          if (error.error.statusCode === 422) {
            this.error = error.error.message;
            const singleString = [].concat(...Object.values(this.error)).join(' ');
            console.log(singleString);
            this.toasterService.error('', singleString);
            this.disabledAddButton[i][j] = true;
          } else {
            this.disabledAddButton[i][j] = false;
            this.error = {};
            this.toasterService.error('', (error.error.message) ? error.error.message : error.message);
          }
        }
      );
  }

  onSubmitQuestionFrom(form: NgForm) {
    if (form.invalid) {
      Object.values(form.controls).forEach(control => control.markAsTouched());
      return;
    }

    console.log('Form submitted:', this.formDataQuestion);
    const apiUrl = 'v2/add-question';
    let param = {
      user_question: this.formDataQuestion.question,
      translated_question: this.formDataQuestion.translation,
      english_question: this.formDataQuestion.english_question,
      question_keywords: this.formDataQuestion.keywords,
      is_core_question: this.formDataQuestion.isCore,
      pinecone_updated: 0,
      related_question: [],
    }
    if (this.activeGroupId) {
      param['group_id'] = this.activeGroupId;
    }
    this.apiService.callPostAPI(apiUrl, param, environment.userApiUrl)
      .subscribe(
        (data: any) => {
          console.log("🚀 ~ SearchComponent ~ onSubmitQuestionFrom ~ data:", data)
          this.questionList.unshift(data.response);
          this.formData.core_questions.push(data.response.id);
          form.resetForm()
          this.toasterService.success('', 'This Question add successfully and append in search list');
          setTimeout(() => {
            this.activeGroupId = parseInt(data['response']['group_id']);
          }, 2000)

          return;
        },
        (error) => {
          console.log('error', error)

        }
      );
  }


  onSubmitFrom(form: NgForm) {
    if (form.invalid) {
      Object.values(form.controls).forEach(control => control.markAsTouched());
      return;
    }
    console.log('Form submitted:', this.formData);
    const apiUrl = 'v2/add-question';
    const param = {
      user_question: this.formData.question,
      translated_question: this.formData.translation,
      english_question: this.formData.english_question,
      question_keywords: this.formData.keywords,
      is_core_question: this.formData.isCore,
      pinecone_updated: 0,
      related_question: this.formData.core_questions,
    }
    this.apiService.callPostAPI(apiUrl, param, environment.userApiUrl)
      .subscribe(
        (data: any) => {
          if (this.formData.core_questions.length > 0) {
            form.resetForm()
            this.init_model = false;
          }
          this.formData.group_id = data['response']['group_id'];
          this.questionText = "";
          this.questionList = [];
          this.formData.core_questions = [];
          this.toasterService.success('', 'This Question add successfully');
          return;
        },
        (error) => {
          console.log('error', error)
          if (error.error.statusCode === 422) {
            this.error = error.error.message;
            const singleString = [].concat(...Object.values(this.error)).join(' ');
            console.log(singleString);
            this.toasterService.error('', singleString);
          } else {
            this.error = {};
            this.toasterService.error('', (error.error.message) ? error.error.message : error.message);
          }
        }
      );
  }





  checkUser() {
    // Single audio play gate: sign-in, then subscription OR remaining
    // free minutes. See AudioService.canPlayAudio().
    return this.audioService.canPlayAudio();
  }

  getIndex(): number {
    this.indexAudio = this.indexAudio + 1;
    return this.indexAudio - 1;
  }

  convertTimeToSeconds(timeStr: string): number {
    const [hours, minutes, seconds] = timeStr.split(':');
    const [sec, millis] = seconds.split(',');

    return (
      parseInt(hours, 10) * 3600 +
      parseInt(minutes, 10) * 60 +
      parseInt(sec, 10) +
      parseInt(millis, 10) / 1000
    );
  }


  getPlayedVideo(slug: any) {
    this.ngOnDestroy();
    this.init_video = true;
    this.apiService
      .callGetAPI('v2/watchvideo/' + slug)
      .subscribe(
        (data) => {
          this.video = data['response']['videos'];
          setTimeout(() => {
            this.decrypt();
          }, 1);
        },
        (error) => {
          this.apiService.failureResponse(error, true);
        }
      );
  }





  playThis(e: any) {
    this.startTime = e.metadata.start ? this.convertTimeToSeconds(e.metadata.start) : null;
    this.endTime = e.metadata.end ? this.convertTimeToSeconds(e.metadata.end) : null;
    this.getPlayedVideo(e.asset.slug)
    this.playedVideoSlug = e.asset.slug;
  }

  closeVideo() {
    this.playedVideoSlug = null;
    this.currentVideoTime = null;
    if (this.player) {
      this.player.pause(); // Optionally pause before disposing
      setTimeout(() => {
        this.init_video = false;
      }, 5)
    }
  }

  setPlayerConfig() {
    const getVideo = document.getElementById('videos');
    videojs.Hls.xhr.beforeRequest = options => {
      options.headers = [];
      if (this.video && this.video.is_live === 0) {
        options.headers['Title'] = this.encrypt();
      }
    };
    this.player = videojs(getVideo, {
      playbackRates: [0.25, 0.5, 1, 1.25, 1.5, 2],
      controls: true,
      preload: 'auto',
      fluid: true,
      autoplay: false,
      seekEventPercentage: 30,
      html5: {
        nativeAudioTracks: false,
        nativeVideoTracks: false,
        nativeTextTracks: false,
        hls: {
          overrideNative: true,
          customDrm: {
            keys:
              'MjMyOGMwYWM4MmNhM2ZjNmY4ZDcyNzI0NWQzMDgzYmUxMzU3ZjA0NGZmNWNiNGMzYTExNDJiMDkzY2YyZjNjOTAwNTM0MjE4NTUxMmM5ODlhMWYwMzI3YjQwYmY3YmY1YjE2MDBkMTYzYTA1ZTFkYzE4OWJhMjUwOGM1MTIwODksNDg3MGVjMDY0YzEwODE0MmNjMGZmYmQ2ZmZkZjFlMDhlNzU2YTZkZWYyYzc4MDQ2ODlmZTRhZTBmYzk4NTIyMSxiMmJmNWE5NzAwNGJiMzFkNmY1YTljMmM4NDQ0OTc1OQ'
          }
        }
      },
      tracks: this.setTracks(),
      plugins: {
        hlsQualitySelector: {},
        seekButtons: {
          forward: 10,
          back: 10
        },
        keyboardShortCuts: {},
        spriteThumbnails: {}
      }
    });
    this.player.play();
    this.playVideo()
  }

  secondsToTimeFormat(seconds) {
    // Calculate hours, minutes, seconds, and milliseconds
    const hrs = Math.floor(seconds / 3600);
    const mins = Math.floor((seconds % 3600) / 60);
    const secs = Math.floor(seconds % 60);
    const ms = Math.floor((seconds % 1) * 1000); // If input has milliseconds (e.g., 450.860)

    // Format each part to two digits (or three for milliseconds)
    const formattedHrs = String(hrs).padStart(2, '0');
    const formattedMins = String(mins).padStart(2, '0');
    const formattedSecs = String(secs).padStart(2, '0');
    const formattedMs = String(ms).padStart(3, '0');

    return `${formattedHrs}:${formattedMins}:${formattedSecs},${formattedMs}`;
  }
  playVideo() {
    this.playedAudioSlug = null;
    this.currentVideoTime = null;
    this.player.autoplay(true)
    this.player.src({
      src: this.video.hls_playlist_url,
      type: 'application/x-mpegURL'
    });

    this.player.ready(() => {
      this.player.currentTime(this.startTime);
      this.player.play();
    });

    this.player.on('timeupdate', () => {
      const currentTime = this.player.currentTime();
      this.currentVideoTime = this.secondsToTimeFormat(currentTime)
      // if (Math.ceil(currentTime) == Math.floor(this.endTime)) {
      //   setTimeout(() => {
      //     this.pausedVideo()
      //   }, 1000)
      // }
    });
  }

  pausedVideo() {
    this.player.pause();
  }

  setTracks() {
    if (this.video && this.video.subtitle) {
      if (this.video.subtitle.subtitle_list.length > 0) {
        this.video.subtitle.subtitle_list.forEach(element => {
          this.subTitle.push({
            title: 'subtitles',
            kind: 'subtitles',
            language: element.language,
            label: element.label,
            src: this.video.subtitle.base_url + element.url,
            default: element.default
          });
        });
        this.subTitle.push({});
      }
      return this.subTitle;
    } else {
      return [];
    }
  }



  decrypt() {
    if (typeof this.video.passphrase !== 'undefined') {
      const cipherParams = CryptoJS.lib.CipherParams.create({
        ciphertext: CryptoJS.enc.Hex.parse(this.video.passphrase)
      });
      this.decrypted = CryptoJS.AES.decrypt(
        cipherParams,
        CryptoJS.enc.Hex.parse(environment.crypto_key),
        {
          keySize: 256,
          iv: CryptoJS.enc.Hex.parse(environment.crypto_iv),
          mode: CryptoJS.mode.CBC
        }
      );
      const change = this.decrypted.toString(CryptoJS.enc.Utf8);
      this.plainText = parseInt(this.hexToBinary(change), 10);
      this.incrementInterVal();
    }
  }
  encrypt() {

    const utf8 = CryptoJS.enc.Utf8.parse('vplayed/' + this.plainText);
    const hex_utf = utf8.toString(CryptoJS.enc.Utf8);
    const hex = this.binaryToHex(hex_utf);
    this.encrypted = CryptoJS.AES.encrypt(
      hex,
      CryptoJS.enc.Hex.parse(environment.crypto_key),
      {
        keySize: 256,
        iv: CryptoJS.enc.Hex.parse(environment.crypto_iv),
        mode: CryptoJS.mode.CBC
      }
    );
    this.cipherText = this.encrypted.ciphertext.toString(CryptoJS.enc.utf8);
    return this.cipherText;
  }
  incrementInterVal() {
    this.interVal = setInterval(
      function () {
        this.plainText += 1;
      }.bind(this),
      1000
    );
    this.setPlayerConfig();
  }

  hexToBinary(num) {
    const hex = num,
      bytes = [];
    for (let i = 0; i < hex.length - 1; i += 2) {
      bytes.push(parseInt(hex.substr(i, 2), 16));
    }
    return String.fromCharCode.apply(String, bytes);
  }

  binaryToHex(num) {
    let str = '',
      i = 0;
    const tmp_len = num.length;
    let c;
    for (; i < tmp_len; i += 1) {
      c = num.charCodeAt(i);
      str += this.d2h(c);
    }
    return str;
    // return parseInt(num, 2).toString(16);
  }
  d2h(d) {
    return d.toString(16);
  }



  downloadTextFile(textContent: string, slug: string) {
    const blob = new Blob([textContent], { type: 'text/plain' });
    const url = window.URL.createObjectURL(blob);

    // Create an anchor element
    const anchor = document.createElement('a');
    anchor.href = url;
    anchor.download = slug + '.txt';

    // Programmatically click the anchor to trigger download
    anchor.click();

    // Cleanup the object URL
    window.URL.revokeObjectURL(url);
  }



  // group all code here

  search_group_fn() {
    this.deleteQuestionId = [];
    this.search_group = !this.search_group;
    this.getGroup();
  }

  title = 'Question Groups';
  activeGroup: string | null = null;
  activeQuestions: any[] = [];
  activeSingleQuestions: number;
  questionGroups: any = [];
  group_answers: any = [];
  group_loader: boolean = false;
  group_loader_question: boolean = false;
  isExpanded: number;
  searchKeyword: string = "";
  defaultOtionLoader: boolean = false;
  selectedGroups: { [key: number]: any } = {};
  add_group_question_model: boolean = false;
  activeGroupId: number = null;
  activeAnswersQuestionId: any = null;
  update_answer_form: boolean = false;
  answerForm: any;
  deleteQuestionId = [];
  allQuestions = [];

  add_more_question(status: boolean) {
    const id = this.getValueByLabel(this.activeGroup, this.groupLists);
    if (status) {
      this.activeGroupId = id;
    } else {
      this.activeGroupId = null;
    }
    this.add_group_question_model = status;
  }

  getValueByLabel(label: string, options: any) {
    const match = options.find(option => option.label === label);
    return match ? match.value : null;
  }

  getGroup = (activeGroup = null) => {
    this.group_loader_question = true
    this.activeQuestions = [];
    this.group_answers = [];
    this.apiService
      .callGetAPI("v2/group-question-answer-xref?search=" + this.searchKeyword, environment.userApiUrl)
      .subscribe(
        (response) => {
          this.group_loader_question = false
          // Transform the API response to match our expected format
          this.questionGroups = Object.keys(response['response']).map(key => ({
            key: key,
            questions: response['response'][key] // Access the nested response data
          }));
          console.log("questionGroups loaded:", this.questionGroups);

          if (activeGroup) {
            this.showGroupQuestions(activeGroup)
          }
          return true
        },
        (error) => {
          this.group_loader_question = false
          this.apiService.failureResponse(error, true);
          console.error("Error loading questionGroups:", error);
        }
      );
  }

  getGroupBySearch() {
    this.deleteQuestionId = [];
    this.getGroup();
  }

  getAnswers = (id: any) => {
    this.activeAnswersQuestionId = id;
    this.group_loader = true;
    this.apiService
      .callGetAPI("v2/get-answers-by-id?id=" + id, environment.userApiUrl)
      .subscribe(
        (response) => {
          this.group_loader = false;
          // Transform the API response to match our expected format
          this.group_answers = response['response']
          console.log("group_answers loaded:", this.group_answers);
        },
        (error) => {
          this.group_loader = false;
          this.apiService.failureResponse(error, true);
          console.error("Error loading questionGroups:", error);
        }
      );
  }

  getAllQuestions = (search = "") => {
    let url: any;
    if (search == "") {
      url = "v2/question";
    } else {
      url = "v2/question/search=" + search;
    }
    this.apiService
      .callGetAPI(url, environment.userApiUrl)
      .subscribe(
        (response) => {
          this.allQuestions = response['response'];
        },
        (error) => {
          this.apiService.failureResponse(error, true);
          console.error("Error loading questionGroups:", error);
        }
      );
  }

  getAnswerSingleQuestion(e: any) {
    this.activeSingleQuestions = e;
    this.getAnswers(e)
  }

  getGroupNames(): string[] {
    return Object.keys(this.questionGroups);
  }

  getGroupDisplayName(groupKey: string): string {
    return groupKey.replace('_', ' ').toUpperCase();
  }

  showGroupQuestions(groupKey: string): void {
    this.activeSingleQuestions = null;
    const foundGroup = this.questionGroups.find(group => group.key === groupKey);
    //  && (groupKey != this.activeGroup)
    if (foundGroup) {
      this.activeGroup = groupKey;
      this.activeQuestions = foundGroup.questions.questions;
      this.activeQuestions.forEach((question) => {
        this.selectedGroups[question.id] = question.group_id || "";
      });
      const ids = this.activeQuestions.map(question => question.id);
      this.getAnswers(ids.join(','))
    } else {
      this.group_answers = [];
      // this.activeGroup = null;
      this.activeQuestions = [];
    }
  }

  goBack(): void {
    this.activeGroup = null;
    this.activeQuestions = [];
  }

  isDeleted(id: number) {
    return this.deleteQuestionId.includes(id);
  }

  questionAfterAction(id: number, message: string) {
    if (!this.deleteQuestionId.includes(id)) {
      this.deleteQuestionId.push(id);
    }
    let div = document.getElementById(id + '_wrapper_of_question');
    let messageOfQuestion = document.getElementById(id + '_message_of_question')
    if (messageOfQuestion) {
      messageOfQuestion.innerHTML = `
          <div class="new-content">
              <p>${message}</p>
          </div>
      `;
    }
    div.style.pointerEvents = 'none';
    div.style.opacity = '0.6'; // optional
  }


  questionAction(api: any, id: number) {

    let url: any;
    if (api == 1) {
      url = "v2/remove-question-from-group/";
    } else if (api == 2) {
      url = "v2/make-core-question/";
    } else if (api == 3) {
      url = "v2/remove-question/";
      const confirmed = window.confirm('Are you sure you want to delete this question?');
      if (!confirmed) {
        return;
      }
    } else if (api == 4) {
      url = "v2/visible-to-user/";
    } else if (api == 5) {
      url = "v2/assign-new-group/";
    } else if (api == 6) {
      url = "v2/remove-answer/";
      const confirmed = window.confirm('Are you sure you want to delete this answer?');
      if (!confirmed) {
        return;
      }
    }

    this.apiService
      .callGetAPI(url + id, environment.userApiUrl)
      .subscribe(
        (response) => {
          this.toasterService.success('', response['message']);
          if (api == 3) {
            this.questionAfterAction(id, 'This is deleted question');
          } else if (api == 5) {
            this.questionAfterAction(id, 'This question removed From this group');
          } else if (api == 2 || api == 4) {
            this.updateUserInList(this.activeQuestions, response['response'])
          } else {
            this.getGroup(this.activeGroup);
          }
          if (api == 5) {
            this.getGroupALL()
          }
          console.log("group_answers loaded:", this.group_answers);
        },
        (error) => {
          this.apiService.failureResponse(error, true);
          console.error("Error loading questionGroups:", error);
        }
      );
  }


  getQuestionListRelated(id: number) {
    if (id == 0) {
      this.questionRelatedList = [];
      return;
    }
    this.apiService
      .callGetAPI("v2/related-questions/" + id, environment.userApiUrl)
      .subscribe(
        (response) => {
          this.questionRelatedList = response["response"];
        },
        (error) => {
          console.error("Error loading questionGroups:", error);
        }
      );
  }




  editQuestion(e: any) {
    console.log("🚀 ~ SearchComponent ~ editQuestion ~ editQuestion:", e)
    this.formUpdateQuestion.id = e.id;
    this.formUpdateQuestion.user_question = e.user_question;
    this.formUpdateQuestion.translation = e.translated_question;
    this.formUpdateQuestion.question_keywords = e.question_keywords;
    this.formUpdateQuestion.is_core_question = e.is_core_question;
    this.formUpdateQuestion.english_question = e.english_question;
    this.formUpdateQuestion.is_active = e.is_active;
    this.formUpdateQuestion.visible_to_user = e.visible_to_user;
    this.formUpdateQuestion.no_good_question = e.no_good_question;
    this.formUpdateQuestion.group_id = e.group_id == null ? "" : e.group_id;
    this.update_question_form = true;

  }
  ngOnDestroyUpdateQuestion() {
    this.update_question_form = false;
  }

  ngOnDestroyUpdateOption() {
    this.update_option_form = !this.update_option_form;
  }


  updateUserInList(userList, result) {
    const index = userList.findIndex(user => user.id === result.id);
    if (index !== -1) {
      userList[index] = { ...userList[index], ...result };
    }
  }

  onUpdateQuestionFrom(e: any) {
    let formData = e.form.value
    formData.translated_question = e.form.value.translation;
    console.log("🚀 ~ SearchComponent ~ onUpdateQuestionFrom ~ onUpdateQuestionFrom:", formData)

    this.apiService.callPostAPI('v2/update-question', formData, environment.userApiUrl)
      .subscribe(
        (data: any) => {
          // this.getGroup(this.activeGroup);
          this.ngOnDestroyUpdateQuestion();
          this.toasterService.success('', data.message);
          this.updateUserInList(this.activeQuestions, data.response)
        },
        (error) => {
          console.log('error', error)
        }
      );

  }

  toggleReadMore(e: number) {
    console.log(e)
    if (this.isExpanded != e) {
      this.isExpanded = e
    } else {
      this.isExpanded = null
    }
  }

  onUpdateOptionFrom() {
    this.defaultOtionLoader = true;
    const formData = {
      option_group: "llm_default_admin_option",
      query_method: this.selectedMechanismValue,
      query_index: this.selectedindexValue,
      batch_name: this.selectedBatchValue,
      alpha: this.value == 0 ? "" : this.value,
      top_k: this.top_k,
      top_k_rerank: this.top_k_rerank,
      rerank_option: this.selectedRerankValue,
      use_qna: this.selectedllmqaValue,
      pinecone_similarity_threshold: this.selected_pinecone_similarity_threshold,
      llm_score_threshold: this.selected_llm_score_threshold,
      user_answer_threshold: this.selected_user_answer_threshold,
      qna_threshold_1: this.selected_qna_threshold_1,
      qna_threshold_2: this.selected_qna_threshold_2,
      translation_model: this.translationModel,
      rerank_model: this.rerankModel,
    };

    this.apiService.callPostAPI('v2/update-option-list', formData, environment.userApiUrl)
      .subscribe(
        (data: any) => {
          this.defaultOtionLoader = false
          this.update_option_form = false;
          this.getAllDefaultOption();
          this.toasterService.success('', "Update default filter successfully, please reload the page");
        },
        (error) => {
          this.defaultOtionLoader = false
          console.log('error', error)
        }
      );
  }

  onGroupChangeFromQuestion(group_id: number, question_id: number) {
    const formData = {
      group_id: group_id,
      question_id: question_id
    }
    this.apiService.callPostAPI('v2/assign-other-group', formData, environment.userApiUrl)
      .subscribe(
        (data: any) => {
          // this.getGroup(this.activeGroup);
          this.toasterService.success('', "Update group successfully");
        },
        (error) => {
          console.log('error', error)
        }
      );
  }

  onSubmitQuestionGroupFrom(e: any) {
    const formData = {
      group_id: this.activeGroupId,
      question_id: this.formData.core_questions
    }
    this.apiService.callPostAPI('v2/update-questions-group', formData, environment.userApiUrl)
      .subscribe(
        (data: any) => {
          this.getGroup(this.activeGroup);
          this.resetFormData();
          this.toasterService.success('', "Update group successfully");
        },
        (error) => {
          console.log('error', error)
        }
      );
  }

  onAssetTime(id: number, time: string, question_id: number) {
    let formData = {
      id: id,
      time: time
    }
    this.apiService.callPostAPI('v2/update-asset-time', formData, environment.userApiUrl)
      .subscribe(
        (data: any) => {
          this.getAnswers(this.activeAnswersQuestionId)
          this.toasterService.success('', data.message);
        },
        (error) => {
          console.log('error', error)
        }
      );
  }

  isAnswerUpdateForm(status: boolean, answer: object = null) {
    if (answer) {
      this.answerForm = answer;
    } else {
      this.answerForm = null;
    }
    this.update_answer_form = status;
  }

  updateAnswerQuestionId(answer: any) {
    this.answerForm = answer
    console.log("🚀 ~ SearchComponent ~ updateAnswerQuestionId ~ ", answer)
    this.onUpdateAnswerFrom();

  }

  onUpdateAnswerFrom() {
    this.apiService.callPostAPI('v2/update-answer', this.answerForm, environment.userApiUrl)
      .subscribe(
        (data: any) => {
          this.getAnswers(this.activeAnswersQuestionId)
          this.toasterService.success('', data.message);
          this.update_answer_form = false
        },
        (error) => {
          console.log('error', error)
          if (error.error.statusCode === 422) {
            this.error = error.error.message;
            const singleString = [].concat(...Object.values(this.error)).join(' ');
            console.log(singleString);
            this.toasterService.error('', singleString);
          } else {
            this.error = {};
            this.toasterService.error('', (error.error.message) ? error.error.message : error.message);
          }
        }
      );
  }


}
